module.exports = __webpack_public_path__ + "img/advantage3.2d1651bf.png";